var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoChat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1491",
    "data-name": "Group 1491",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.299,
    height: 34.126,
    viewBox: "0 0 23.299 34.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1323",
    "data-name": "Rectangle 1323",
    width: 23.299,
    height: 34.126,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1322",
    "data-name": "Rectangle 1322",
    width: 23.299,
    height: 34.127,
    transform: "translate(0 -0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1321",
    "data-name": "Rectangle 1321",
    width: 5.141,
    height: 11.662,
    transform: "translate(5.671 22.465)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1319",
    "data-name": "Rectangle 1319",
    width: 2.117,
    height: 6.251,
    transform: "translate(4.613 16.969)",
    fill: "#c0392b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25742",
    "data-name": "Path 25742",
    d: "M10.627,27.017l-.493-.953-1.4-2.706a1.652,1.652,0,0,0-1.468-.893H3.523a1.652,1.652,0,0,0-1.47.9l-1.4,2.721-.477.939A1.657,1.657,0,0,0,0,27.769v4.7a1.654,1.654,0,0,0,1.653,1.653H9.159a1.653,1.653,0,0,0,1.653-1.653v-4.7a1.659,1.659,0,0,0-.185-.76",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25743",
    "data-name": "Path 25743",
    d: "M10.135,26.064l-1.4-2.706a1.653,1.653,0,0,0-1.468-.893H3.524a1.654,1.654,0,0,0-.38.047c0,.022-.007.043-.007.066a.779.779,0,0,0,.8.766H7.61a.749.749,0,0,1,.713.814v.032a.808.808,0,0,1-.713.877H5.374c-.441,0-.8.24-.8.671s.358.67.8.67H7.93a.864.864,0,0,1,0,1.724H4.815a.767.767,0,1,0,0,1.532H9.448a.767.767,0,1,1,0,1.532H6.492a.767.767,0,1,0,0,1.532H8.17a.862.862,0,0,1,.8.862.9.9,0,0,1-.192.536H9.16a1.653,1.653,0,0,0,1.653-1.653v-4.7a1.655,1.655,0,0,0-.185-.759Z",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25744",
    "data-name": "Path 25744",
    d: "M10.812,32.473v-.62H0v.62a1.653,1.653,0,0,0,1.653,1.653H9.159a1.653,1.653,0,0,0,1.653-1.653",
    fill: "#c0392b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1320",
    "data-name": "Rectangle 1320",
    width: 6.251,
    height: 2.116,
    transform: "matrix(0.643, -0.766, 0.766, 0.643, 7.329, 15.041)",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25745",
    "data-name": "Path 25745",
    d: "M2.686,6.924a.769.769,0,0,0-1.23.379A11.542,11.542,0,0,0,17.592,20.841a.768.768,0,0,0,.159-1.276Z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25746",
    "data-name": "Path 25746",
    d: "M1.483,7.272A9.644,9.644,0,0,0,1.094,9.39L15.606,21.566a9.751,9.751,0,0,0,2-.746.746.746,0,0,0,.141-1.255L2.687,6.924a.738.738,0,0,0-1.2.348",
    fill: "#c0392b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25747",
    "data-name": "Path 25747",
    d: "M13.264,11.86a1.449,1.449,0,0,1-2.212-1.855,1.449,1.449,0,0,1,2.212,1.855",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25748",
    "data-name": "Path 25748",
    d: "M10.135,26.064l-1.4-2.706a1.653,1.653,0,0,0-1.468-.893H5.671V34.126H9.16a1.653,1.653,0,0,0,1.653-1.653v-4.7a1.655,1.655,0,0,0-.185-.759Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_25749",
    "data-name": "Path 25749",
    d: "M23,11.374A11.074,11.074,0,0,0,11.925.3",
    fill: "none",
    stroke: "#c44538",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25750",
    "data-name": "Path 25750",
    d: "M19.916,11.009A7.626,7.626,0,0,0,12.29,3.383",
    fill: "none",
    stroke: "#c44538",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25751",
    "data-name": "Path 25751",
    d: "M17.017,10.673a4.391,4.391,0,0,0-4.391-4.391",
    fill: "none",
    stroke: "#c44538",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChat1);
export default __webpack_public_path__ + "static/media/no-chat-1.269a55cabc6884cd0d8d9e49aa2f6c32.svg";
export { ForwardRef as ReactComponent };